<div class="container-fluid">
    <!-- For posting/asking questions -->
    <div>
        <h5 class="text-center mb-2 mt-2">Post Question</h5>
        <mat-form-field appearance="fill">
            <mat-label>Select lecture</mat-label>
            <mat-select name="lecture" (selectionChange)="getResourceId($event)">
                <mat-option value="none">General Question</mat-option>
                <mat-option [value]="resource.resource_id"
                    *ngFor="let resource of resourcesArray">{{resource.resource}}</mat-option>
            </mat-select>
        </mat-form-field>

        <mat-form-field class="example-full-width" appearance="fill">
            <mat-label>Question Title</mat-label>
            <input matInput [(ngModel)]="title">
        </mat-form-field>

        <mat-form-field class="example-full-width" appearance="fill">
            <mat-label>Question</mat-label>
            <input matInput [(ngModel)]="question">
        </mat-form-field>

        <button class="btn mb-3" color="primary" mat-raised-button (click)="addQuestion()">Post Question</button>
    </div>
    <!--  -->
</div>